/**
 * @class
 */
import Base from 'netxcore@netx/core-category/collections/categoryTreeNodes';

export default class CategoryTreeNodes extends Base {
	/**
	 * Do not return top level - 1 or "the more option"
	 * @override
	 */
	parseSearchCats(data) {
		data = _.filter(data, (d) => d.value && d.value != 1);
		return super.parseSearchCats(data);
	}
}
